@if (likeable.likes.count) {
  <span class="community-feed-item-like">
    <button class="func-link" (click)="showLikes()" attr.aria-label="Open Likes Modal for {{likeable.type}} {{likeable.title ? (likeable.title | emojiText) : ''}}, by {{likeable.user.name}}, {{likeable.likes.count | utNumToK}} {{likeable.likes.count !== 1 ? 'Likes' : 'Like'}}">{{likeable.likes.count | utNumToK}} {{likeable.likes.count !== 1 ? 'Likes' : 'Like'}}</button>
  </span>
}
@if (!likeable.likes.count) {
  <span class="community-feed-item-like">0 Likes</span>
}
